import { render } from "./EbmTransactionStatsCard.vue?vue&type=template&id=51a06873&scoped=true"
import script from "./EbmTransactionStatsCard.vue?vue&type=script&lang=js"
export * from "./EbmTransactionStatsCard.vue?vue&type=script&lang=js"

import "./EbmTransactionStatsCard.vue?vue&type=style&index=0&id=51a06873&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a06873"]])

export default __exports__